import { defineComponent as _defineComponent } from 'vue'
import { useAuthStore } from '@/store/pinia/auth'
import LogosMap from '@/v2/components/logos/LogosMap.vue'
import DropMenuProfile from '@/v2/components/profile-menu/DropMenuProfile.vue'
import SearchBar from '@/v2/components/search-bar/SearchBar.vue'
import { computed } from 'vue'
import { RouterLink } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const authStore = useAuthStore()

const showSearchBar = computed(() => {
  return authStore.isPhysician
})

return { __sfc: true,authStore, showSearchBar, LogosMap, DropMenuProfile, SearchBar, RouterLink }
}

})